import { Column } from "@faire/web/slate/Layout";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
import { CONTACT_CARDS_COMBINED_WIDTH } from "../../consts";
export var LimitedWidthWrapper = styled(Column).attrs({
  align: "flex-start"
}).withConfig({
  displayName: "LimitedWidthWrapper"
})(["", "{max-width:", ";}width:100%;"], responsiveMediaQueries.tabletAndAbove, CONTACT_CARDS_COMBINED_WIDTH);